import { useSuspenseQuery } from "@apollo/client";
import { GET_ALL_DYNAMIC_PROCESS_CANDIDATES } from "../api/get-all-dynamic-process-candidates";

export function useAllDynamicProcessCandidates() {
  return useSuspenseQuery(GET_ALL_DYNAMIC_PROCESS_CANDIDATES);
}
